import { useTranslation } from 'react-i18next';
import DebouncedInput from 'src/components/DebouncedInput';
import { jsx as _jsx } from "react/jsx-runtime";
export function Text(_ref) {
  var _column$getFilterValu;

  var column = _ref.column,
      isDisabled = _ref.isDisabled;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(DebouncedInput, {
    bg: "white",
    type: "text",
    px: 2,
    placeholder: t('common:button.search', '搜尋'),
    value: (_column$getFilterValu = column.getFilterValue()) !== null && _column$getFilterValu !== void 0 ? _column$getFilterValu : '',
    onChange: function onChange(value) {
      return column.setFilterValue(value);
    },
    isDisabled: isDisabled,
    e2eid: "Filter_Text_DebouncedInput"
  });
}